import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { ArrowRight } from "lucide-react";

const Resources = () => {
  const { t } = useI18n();
  return (
    <>
      <section className="bg-[#0F1B2D] text-white pt-36 pb-20 relative grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="overline text-[#C4A46A]">{t.resources.kicker}</div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">{t.resources.title}</h1>
          <span className="gold-rule mt-8 block" />
        </div>
      </section>

      <section className="bg-[#F4F0E8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
          <div className="flex flex-wrap gap-3 mb-12" data-testid="resource-categories">
            {t.resources.categories.map((c) => (
              <span
                key={c}
                className="px-4 py-2 text-[11px] tracking-[0.24em] uppercase font-bold border border-[#0F1B2D]/25 text-[#0F1B2D]"
              >
                {c}
              </span>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0F1B2D]/10">
            {t.resources.items.map((r, i) => (
              <article
                key={r.t}
                data-testid={`resource-${i}`}
                className="bg-[#F4F0E8] p-10 flex flex-col justify-between min-h-[260px] hover:bg-white transition-colors"
              >
                <div>
                  <div className="overline">{r.c}</div>
                  <h3 className="mt-4 font-display text-xl lg:text-2xl text-[#0F1B2D] tracking-tight">
                    {r.t}
                  </h3>
                  <p className="mt-4 text-[#5E6470] text-sm leading-relaxed">{r.d}</p>
                </div>
                <div className="mt-8 inline-flex items-center gap-2 text-[#0F1B2D] text-[11px] tracking-[0.24em] uppercase font-bold">
                  {t.common.readMore} <ArrowRight size={12} />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Resources;
